export function triggerBlobDownload(blob: Blob, fileName?: string) {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;

  if (fileName) {
    link.download = fileName;
  }

  document.body.appendChild(link);
  link.click();
  link.remove();

  window.setTimeout(() => {
    window.URL.revokeObjectURL(objectUrl);
  }, 0);
}

export function normalizeContentType(contentType?: string | null) {
  if (!contentType) {
    return '';
  }

  return contentType
    .toLowerCase()
    .replace(/\s*;\s*/g, ';')
    .trim();
}

export function getExtensionFromContentType(contentType?: string | null): string {
  const normalized = normalizeContentType(contentType);

  if (!normalized) {
    return '';
  }

  const contentTypeMap: Record<string, string> = {
    'image/png': '.png',
    'image/jpeg': '.jpg',
    'video/mp4': '.mp4',
    'application/zip': '.zip',
    'text/plain': '.txt',
    'model/stl': '.stl',
    'model/gltf+json': '.gltf',
    'model/gltf-binary': '.glb',
    'application/vnd.rhino.3d': '.3dm',
    'image/vnd.dxf': '.dxf',
    'text/csv': '.csv',
    'application/csv': '.csv',
    'application/vnd.ms-excel': '.csv',
    'text/tab-separated-values': '.tsv',
    'application/json': '.json',
  };

  return contentTypeMap[normalized] || contentTypeMap[normalized.split(';')[0]] || '';
}

export function buildDownloadFileName(file?: { name?: string | null; contentType?: string | null } | null) {
  const normalizedName = (file?.name ?? '').trim();
  const extension = getExtensionFromContentType(file?.contentType);

  if (!normalizedName || !extension || normalizedName.toLowerCase().endsWith(extension.toLowerCase())) {
    return normalizedName;
  }

  return `${normalizedName}${extension}`;
}
